import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import axios from "axios";
import background from '../../img/background.jpg';

const BackgroundImage = ({children}) => {
    const userLogin = useSelector(state => state.userLogin);
    const { userInfo } = userLogin;

    const [photo, setPhoto] = useState("")

    // Depend on what the request actually uses, not the whole user object. /api/background returns a
    // random photo for the query, and refreshUser() merges a fresh userInfo into the store on every
    // page load — so keying on the object re-rolled the wallpaper a second time mid-load, visibly
    // swapping the background for no reason.
    const bgQuery = userInfo?.settings?.bgQuery ?? 'nature';
    const loggedIn = Boolean(userInfo);
    useEffect(() => {
        async function getPhoto() {
            const config = {
                headers: {
                    "Content-type": "application/json"
                }
            }

            const { data } = await axios.post(`/api/background`, {query: bgQuery}, config);
            setPhoto(data.url);
        }
        getPhoto();
    }, [bgQuery, loggedIn]);

    return (
        <div
            style={{
                backgroundImage: userInfo ? `url(${photo})` : `url(${background})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                WebkitTouchCallout: "none",
                WebkitUserSelect: "none",
                KhtmlUserSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
                userSelect: "none",
                pointerEvents: "none"
            }}
             className='mx-auto flex flex-col min-h-screen overflow-hidden sm:break-words md:break-normal'
        >
            <div className={'w-full mx-auto flex flex-col min-h-screen overflow-hidden sm:break-words md:break-normal'} style={{pointerEvents: "auto"}}>
                {children}
            </div>
        </div>
    );
};

export default BackgroundImage;